// extracted by mini-css-extract-plugin
export default {"root":"IconButton_root__GKLaF","p-disabled":"IconButton_p-disabled__wL7ge"};